@if (
  this.listData &&
  this.listData.expandableListItems &&
  this.listData.expandableListItems.length > 0
) {
  <mat-list class="border-2 h-fit border-solid border-gray-300 rounded-lg">
    @if (this.listData.totalRow && !this.listData.totalRow.positionBottom) {
      <mat-list-item class="border-b-2 border-solid border-0 border-gray-300">
        <div class="flex flex-row items-center justify-between pl-2">
          <p>{{ this.listData.totalRow.label }}</p>
          <h2>{{ this.listData.totalRow.value }}</h2>
        </div>
      </mat-list-item>
    }
    @if (
      this.listData.headerTemplate && getTemplate(listData.headerTemplate, true)
    ) {
      <ng-container
        [ngTemplateOutlet]="getTemplate(listData.headerTemplate, true)"
      >
      </ng-container>
    }
    @for (
      expandableItem of listData.expandableListItems;
      track expandableItem;
      let index = $index;
      let isLast = $last
    ) {
      <mat-list-item>
        <div
          class="flex flex-row items-center justify-between cursor-pointer w-full border-b border-0 border-solid border-gray-400"
          (click)="toggleExpanded(index)"
          [class.border-b]="!isLast || expandedRow().includes(index)"
        >
          <div class="{{ getClassForHeader(expandableItem) }}">
            @if (
              expandableItem.subItems && expandableItem.subItems.length > 0
            ) {
              <mat-icon>
                {{
                  expandedRow().includes(index)
                    ? 'keyboard_arrow_up'
                    : 'keyboard_arrow_down'
                }}
              </mat-icon>
            }
            @if (
              getTemplate(expandableItem.templateName, true);
              as expandableItemTemplate
            ) {
              <ng-container
                [ngTemplateOutlet]="expandableItemTemplate"
                [ngTemplateOutletContext]="{
                  $implicit: expandableItem,
                  item: expandableItem,
                  index: index,
                }"
              >
              </ng-container>
            } @else {
              <div class="flex flex-row items-center justify-between w-full">
                <span>{{ expandableItem.label }}</span>
                <h3>{{ expandableItem.value }}</h3>
              </div>
            }
          </div>
        </div>
      </mat-list-item>

      @if (expandedRow().includes(index) && expandableItem.subItems) {
        <div class="pl-8">
          <mat-list class="secondary-list">
            @for (
              subItem of expandableItem.subItems;
              track subItem;
              let isLastSubItem = $last
            ) {
              <mat-list-item>
                @if (getTemplate(subItem.templateName); as subItemTemplate) {
                  <ng-container
                    [ngTemplateOutlet]="subItemTemplate"
                    [ngTemplateOutletContext]="{
                      $implicit: subItem,
                      item: subItem,
                      index: index,
                    }"
                  >
                  </ng-container>
                } @else {
                  <div
                    class="flex flex-row items-center justify-between border-b border-0 border-solid border-gray-400"
                    [class.border-b]="!isLastSubItem || !isLast"
                  >
                    <span>{{ subItem.label }}</span>
                    <h4>{{ subItem.value }}</h4>
                  </div>
                }
              </mat-list-item>
            }
          </mat-list>
        </div>
      }
    }
    @if (this.listData.totalRow && this.listData.totalRow.positionBottom) {
      <mat-list-item
        class="border-t-2 border-solid border-0 border-gray-300 mt-2"
      >
        <div class="flex flex-row items-center justify-between pl-2">
          <p>{{ this.listData.totalRow.label }}</p>
          <h2>{{ this.listData.totalRow.value }}</h2>
        </div>
      </mat-list-item>
    }
  </mat-list>
} @else {
  <div class="border-2 h-fit border-solid border-gray-300 rounded-lg">
    <div class="flex flex-col items-center justify-center py-10 gap-4">
      <mat-icon class="text-gray-400">info</mat-icon>
      <p class="text-gray-500">No data available</p>
    </div>
  </div>
}
